import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';
import { default as moment } from 'moment';


const DEFAULT_INPUT_FORMAT = 'YYYY-MM-DD',
  DEFAULT_PRECISION = 'month';

@Pipe({
    name: 'defaultDate',
    standalone: false
})
export class DefaultDatePipe implements PipeTransform {
/*
  DEFAULT_DATE_OUTPUT_PRECISION: Object;

  constructor(injector: Injector) {
    const config = injector.get(APP_CONFIG);
    this.DEFAULT_DATE_OUTPUT_PRECISION = config.get('DEFAULT_DATE_OUTPUT_PRECISION');
    console.log('^^^', config);
  }
*/

  transform(value: any, precision = DEFAULT_PRECISION, autoDetectFormat = false, inLocalTime = true): any {
    const outputFormat = AppConfigService.DEFAULT_DATE_OUTPUT_FORMATS[precision.toLowerCase()]
      || AppConfigService.DEFAULT_DATE_OUTPUT_FORMATS[DEFAULT_PRECISION];

    if (!value) {
      return undefined;
    }

    const date = moment.utc(value, !autoDetectFormat ? DEFAULT_INPUT_FORMAT : undefined);

    if (!date.isValid()) {
      console.error(`[DefaultDatePipe] Date ${value} has invalid format`);
      return undefined;
    }

    if (!inLocalTime) {
      return date.format(outputFormat);
    }

    return date.local().format(outputFormat);
  }
}
